import axios from 'axios';
import API_ENDPOINT from "../wm.api.service";

// const BASE_URL = 'http://192.168.1.19/';
// const BASE_URL = 'http://braso.local.io/';
const BASE_URL = API_ENDPOINT.apiURL;

export default axios.create({
    baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
